import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { MouseEvent } from 'react';

export type FilterDropdownButtonProps = {
  label: string;
  open: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  activeCount?: number;
  controlHeight?: number;
  dataTest?: string;
  isActive?: boolean;
  minWidth?: number;
};

export const FilterDropdownButton = ({
  label,
  open,
  onClick,
  activeCount,
  controlHeight = 40,
  dataTest,
  isActive = false,
  minWidth,
}: FilterDropdownButtonProps) => (
  <Button
    variant="outlined"
    onClick={onClick}
    endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
    data-test={dataTest}
    sx={{
      height: controlHeight,
      minWidth,
      justifyContent: 'space-between',
      textTransform: 'none',
      px: 1.5,
      backgroundColor: theme =>
        isActive
          ? alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
          : theme.palette.background.paper,
      borderColor: theme => (isActive ? theme.palette.primary.main : theme.palette.divider),
      color: 'text.primary',
      '&:hover': {
        backgroundColor: theme =>
          isActive
            ? alpha(
                theme.palette.primary.main,
                theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity
              )
            : theme.palette.action.hover,
        borderColor: theme => (isActive ? theme.palette.primary.main : theme.palette.divider),
      },
    }}
  >
    <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
      <Typography component="span" sx={{ color: 'text.primary', fontWeight: isActive ? 700 : 500 }}>
        {label}
      </Typography>
      {Boolean(activeCount) && (
        <Box
          component="span"
          sx={{
            alignItems: 'center',
            backgroundColor: theme => theme.palette.primary.main,
            borderRadius: 1,
            color: theme => theme.palette.primary.contrastText,
            display: 'inline-flex',
            fontSize: 12,
            fontWeight: 700,
            height: 20,
            justifyContent: 'center',
            minWidth: 20,
            px: 0.5,
          }}
        >
          {activeCount}
        </Box>
      )}
    </Box>
  </Button>
);
